import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTargetModelContext } from '../TargetModelProvider'

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: '20px',
    '& .__name': {
      fontSize: theme.typography.fontSizes.h3
    },
    '& .__desc': {
      fontWeight: theme.typography.weights.light
    }
  }
}))

function TargetModelHeader () {
  const classes = useStyles()
  const { targetModel } = useTargetModelContext()
  return (
    <div className={classes.header}>
      <div className='__name'>{targetModel.name}</div>
      <div className='__desc'>{targetModel.description}</div>
    </div>
  )
}

export default TargetModelHeader
